import React, {useState} from 'react'
import LengthConversions from './LengthConversions';
import MassConversions from './MassConversions';
import LiquidConversions from './LiquidConversions';
import TemperatureConversion from './TemperatureConversion';
import AreaConversion from './AreaConversion';
export default function MetricConversions() {
    const [showLength, setShowLength] = useState(true)
    const [showWeight, setShowWeight] = useState(false)
    const [showWater, setShowWater] = useState(false)
    const [showTemp, setShowTemp] = useState(false)
    const [showArea, setShowArea] = useState(false)
    //Button activation on click
    const [isActive, setIsActive] = useState(false);
    
    const buttonClassOff = "myTabButton"
    const buttonClassOn = "myTabButtonActive"



  return (
    <div style={{border:"solid 1px #F9D081", backgroundColor:"#044744"}}>
        <div >

        <div className='wrapper' id='myTabButtons'>
            <div className="outer" > 
                <button id={buttonClassOff} className= {isActive ? 'active' : ''} onClick={()=>{
                    setShowLength(true)
                    setShowWeight(false)
                    setShowWater(false)
                    setShowTemp(false); 
                    setShowArea(false)
                }}> 
                    <p id='myTabButtonText'>Length</p>
                </button>
            </div>

            


            <div className="outer">
                <button id='myTabButton' onClick={()=>{
                    setShowLength(false)
                    setShowWeight(false)
                    setShowWater(false)
                    setShowTemp(false); 
                    setShowArea(true)
                }}>
                    <p id='myTabButtonText'>
                        Area
                    </p>
                </button>
            </div>
            <div className="outer">
                <button id='myTabButton' onClick={()=>{
                    setShowLength(false)
                    setShowWeight(true)
                    setShowWater(false)
                    setShowTemp(false); 
                    setShowArea(false)
                }}>
                    <p id='myTabButtonText'>Weight</p>
                </button>
            </div>
            <div className="outer">
                <button id='myTabButton' onClick={()=>{
                    setShowLength(false)
                    setShowWeight(false)
                    setShowWater(true)
                    setShowTemp(false); 
                    setShowArea(false)
                }}>
                    <p id='myTabButtonText'>
                        Volume
                    </p>
                </button>
            </div>

            <div className="outer">
                <button id='myTabButton' onClick={()=>{
                    setShowLength(false)
                    setShowWeight(false)
                    setShowWater(false)
                    setShowTemp(true); 
                    setShowArea(false)
                }}>
                    <p id='myTabButtonText'>
                        Temperature
                    </p>
                </button>
            </div>
        </div>
        </div>
        
         {showLength &&  <LengthConversions/>  }
         {showWeight &&  <MassConversions/>}
          {showWater &&  <LiquidConversions/>}
          {showTemp && <TemperatureConversion/>}
          {showArea && <AreaConversion/>}
    </div>
  )
}
